import { getDomain } from "project-config/utils/domain";

export function isFox() {
  return !!getDomain();
}
